import './amtTabValidity';